import { EMAIL_TAKEN, DNI_TAKEN, NO_PROFESSIONAL_ASSIGNED } from '~constants/codes';

export const VALID_INTERNAL_CODES = {
  CASE: [NO_PROFESSIONAL_ASSIGNED],
  CREATION: [EMAIL_TAKEN, DNI_TAKEN],
  EDITION: [EMAIL_TAKEN]
};
